import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../AnimationContents';

import * as PIXI from 'pixi.js';
import { gsap, TweenLite } from 'gsap';
import { GameModel } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';

export class UIOverlay extends AnimationBaseController {
    $model: GameModel;
    private _electricityOverlay: boolean = false;

    private _graphics: PIXI.Graphics;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('UIOverlay');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'overlay_container',
            modelWatch: {
                showMiniGame: (value: boolean) => this.setVisibility(value),
                showMiniMap: (value: boolean) => this.setVisibility(value),
                showTaskScreen: (value: boolean) => this.setVisibility(value),
            },
            onTap: () => {
                //this._gameLogic.resetGameScreen();
            },
        };
    }

    protected onInitialize(): void {
        this._graphics = new PIXI.Graphics();
        this._graphics.visible = false;
        this._graphics.interactive = false;

        this.display.addChild(this._graphics);
    }

    protected onResize(width: number, height: number, scale: number): void {
        const w = width * 10;
        const h = height * 10;

        this._graphics.clear();
        this._graphics.beginFill(0x000000, 0.75);
        this._graphics.drawRect(-w / 2, -h / 2, w, h);
        this._graphics.endFill();
    }

    private setVisibility(value: boolean): void {
        this._graphics.alpha = value ? 0 : 1;
        this._graphics.visible = value;
        this._graphics.interactive = value;

        gsap.killTweensOf(this._graphics);

        TweenLite.to(this._graphics, 0.15, { alpha: value ? 1 : 0 });
    }
}
